import React from 'react';
import { CircularProgress } from '../../../Progress/CircularProgress';
import { LinearProgress } from '../../../Progress/LinearProgress';
import { Fade } from '../../../Fade';
import { styled } from '../../../../styles';

interface LoadingProps {
  loading: boolean | undefined;
}

export const Loading: React.FC<LoadingProps> = ({ loading }) => {
  return (
    <Fade in={loading} unmountOnExit>
      <StyledLoadingContent>
        <CircularProgress shape="bpe" />
      </StyledLoadingContent>
    </Fade>
  );
};

const StyledLoadingContent = styled('div')`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(3px);
    z-index: 2;
`;

export const LoadingBar: React.FC<LoadingProps> = ({ loading }) => {
  return (
    <Fade in={loading} unmountOnExit>
      <StyledLoadingBarContent>
        <LinearProgress />
      </StyledLoadingBarContent>
    </Fade>
  );
};

const StyledLoadingBarContent = styled('div')`
    position: absolute;
    top: 45px;
    right: 0;
    left: 0;
    z-index: 2;
`;
